<template>
    <div class="map" :class="[bemIf(mapViewIsInitted, 'is-initted')]">
        <div class="map--wrap">
            <div class="map--root" ref="map"></div>
        </div>
    </div>
</template>

<script>
    import { touchevents } from 'modernizr';
    import mapStyle from './map-style.json';
    import isMountedMixin from 'vue/mixins/is-mounted';
    import bemMixin from 'vue/mixins/bem';

    const CUSTOM_MAP_TYPE_ID = 'SIB_MAP_STYLE';
    const CUSTOM_MAP_TYPE_NAME = 'SIB';

    export default {
        mixins: [
            isMountedMixin,
            bemMixin('map'),
        ],
        props: {
            mapId: String,
            lat: Number,
            lng: Number,
            name: String,
            formattedAddress: String,
        },
        data() {
            return {
                globals,
                MapsApi: null,
                mapViewIsInitted: false,
                GoogleMaps: null,
                GoogleMapsMarker: null,
            };
        },
        computed: {
            gmapsIsReady() {
                return this.isMounted && this.MapsApi && this.GoogleMaps && this.GoogleMapsMarker;
            },
        },
        watch: {
            gmapsIsReady(val) {
                if (!val || this.mapViewIsInitted) {
                    return;
                }

                const { mapId, lat, lng, name, formattedAddress, MapsApi, GoogleMapsMarker } = this;

                // NOTE: Init map and other map specific constructs
                const CustomMapType = new MapsApi.StyledMapType(mapStyle, { name: CUSTOM_MAP_TYPE_NAME });
                const Map = new MapsApi.Map(this.$refs.map, {
                    center: {
                        lat: 46.8182,
                        lng: 8.2275,
                    },
                    mapTypeControlOptions: {
                        mapTypeIds: [MapsApi.MapTypeId.ROADMAP, CUSTOM_MAP_TYPE_ID],
                    },
                    zoom: 15,
                    scrollwheel: false,
                    draggable: !touchevents,
                    mapId: mapId,
                });
                const InfoWindow = new MapsApi.InfoWindow();

                // NOTE: Implement custom map type and set as active
                Map.mapTypes.set(CUSTOM_MAP_TYPE_ID, CustomMapType);
                Map.setMapTypeId(CUSTOM_MAP_TYPE_ID);

                const location = { lat: lat, lng: lng };

                Map.setCenter(location);
                InfoWindow.setContent(`<div><strong>${ name }</strong><br><span>${ formattedAddress }</span></div>`);

                const advancedMarker = new GoogleMapsMarker.AdvancedMarkerElement({
                    position: { lat: lat, lng: lng },
                    map: Map,
                    title: name,
                });

                MapsApi.event.addListener(advancedMarker, 'click', () => {
                    InfoWindow.open(Map, advancedMarker);
                });

                this.mapViewIsInitted = true;
            },
        },
        mounted() {
            const GoogleMapsApiLoader = new Promise(resolve => {
                require.ensure([], () => {
                    resolve(require('util/google-maps').default); // eslint-disable-line global-require
                }, null, 'google-maps-api-loader');
            });

            GoogleMapsApiLoader
                .then(MapsApi => {
                    this.MapsApi = MapsApi;

                    // Load both "maps" and "marker" libraries
                    return Promise.all([
                        MapsApi.importLibrary('maps'),
                        MapsApi.importLibrary('marker'),
                    ]);
                })
                .then(([googleMaps, googleMapsMarker]) => {
                    // Assign google.maps and google.maps.marker to data properties
                    this.GoogleMaps = googleMaps;
                    this.GoogleMapsMarker = googleMapsMarker;
                })
                .catch(error => {
                    throw error;
                });
        },
    };
</script>



// WEBPACK FOOTER //
// index.vue?4ef246e0